// extracted by mini-css-extract-plugin
export default {"elevateCard":"ElevateCard_elevateCard__HlI50","cardIcon":"ElevateCard_cardIcon__ZS+Rw","cardText":"ElevateCard_cardText__cgDYa"};